const FOR_THIRD_PARTY_USE = true;
let socketio, sockwrap;
let CentionBaseURL;
if (typeof CentionBaseURL === "undefined") {
	CentionBaseURL = "";
}

const CentionChatStatus = {};
if (FOR_THIRD_PARTY_USE) {
  socketio = "//cdn.socket.io/socket.io-1.4.8.js";
	sockwrap = "ClearitChat/sockwrap.js";
} else {
	socketio = CentionBaseURL + "/cention/chat/js/socket.io.js";
	sockwrap = CentionBaseURL + "/cention/chat/js/sockwrap.js";
	if (typeof io === 'undefined') {
    const socketIOScript = document.createElement("script");
    socketIOScript.setAttribute("type", "text/javascript");
		socketIOScript.setAttribute("src", socketio);
		document.head.appendChild(socketIOScript);
	}
	if (typeof SockWrap === 'undefined') {
    const sockWrapScript = document.createElement("script");
    sockWrapScript.setAttribute("type", "text/javascript");
		sockWrapScript.setAttribute("src", sockwrap);
		document.head.appendChild(sockWrapScript);
	}
}

const _CentionChat = function () {
  let that = {};
  let Public = {};
  let chatSock = null;
  let actionHandlers = {};
  let SystemMessage;
  let JSON_ENCODED = "\x01JSON";

  Public.sessionSecret = '';
  Public.sessionId = '';
  Public.areaId = 0;
  Public.activeSession = false;
  that.queuePosition = -1;
  that.mcount = {};
  that.maxAcked = 0;
  // agentSeen keep track of whether the agent has seen the message sent by client.
  // It contains message ids that was sent by the client only.
  that.agentSeen = {};
  Public.baseURL = ""; // May be set by third party client.
  if (typeof I === 'function') {
    Public.I = I;
  } else {
    Public.I = function (text) {
      return text;
    };
  }

  function log() {
    if (window.console && console.log && typeof console.log === "function") {
      console.log.apply(console, arguments)
    }
  }

  function isInt(v) {
    return v === parseInt(v, 10);
  }

  // CentionChatAPI.go: bytesToSize()
  function bytesToSize(bytes) {
    let sizes = ['bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes === 0) {
      return 'n/a';
    }

    let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    if (i === 0) {
      return `${bytes} ${sizes[i]}`;
    }

    return `${(bytes / Math.pow(1024, i)).toFixed(1)} ${sizes[i]}`;
  }

  function isJSONPayload(text) {
    // returns true if text starts with "\x01JSON"
    return text.lastIndexOf(JSON_ENCODED, 0) === 0;
  }

  // CentionChatAPI.go: renderFileUploadMessage()
  function renderFileUploadMessage(j) {
    let html = 
    `<a href="${Public.baseURL}/Cention/web/chat/client/download${escape(j.fileDownload)}?t=${Public.sessionSecret}">
      ${j.fileName}
      <span>(${bytesToSize(j.estimatedSize)})</span>
    </a>`;
    if (j.error) {
      html = `${html}<span>Error: ${j.error}</span>`;
    }
    return html
  }

  SystemMessage = {
    renderSetAgentsEvent: function (m) {
      let text = []
        , byName = function (a, b) {
          if (a < b) {
            return -1;
          }
          if (a > b) {
            return 1;
          }
          return 0;
        }
        , collectNames = function (a) {
          let i = 0
            , r = []
          ;
          for (i = 0; i < a.length; i++) {
            r.push(m.names[a[i]]);
          }
          return r;
        }
        , added = collectNames(m.added)
        , removed = collectNames(m.removed)
      ;

      added.sort(byName);
      removed.sort(byName);

      if (removed.length > 0) {
        text.push(Public.I("Agent(s) removed: {AGENT_NAMES}")
          .replace('{AGENT_NAMES}', removed.join(", ")));
      }
      if (added.length > 0 && !m.byInvitation) {
        text.push(Public.I("Agent(s) added: {AGENT_NAMES}")
          .replace('{AGENT_NAMES}', added.join(", ")));
      }
      if (text.length === 0) {
        return null;
      }
      return text.join(".<br>\n");
    },
    renderAgentLeftEvent: function (m) {
      return Public.I("{AGENT_NAME} has left the chat.").replace("{AGENT_NAME}", m.name);
    },
    renderClientEndsChat: function (m) {
      let text;
      if (m.name === "UNKNOWN") {
        text = Public.I("Client ended the chat.");
      } else {
        text = Public.I("{NAME} ended the chat.").replace("{NAME}", m.name);
      }
      return text;
    },
    renderAttachmentAdded: function (m) {
      return `<a href=\"${Public.baseURL}/Cention/web/chat/client/download/${m.file.download}\">
          ${m.file.value}
          <br />
          <span>(${bytesToSize(m.file.estSize)})
          </span></a>`;
    },
    renderForwardToAgent: function (m) {
      let text;

      text = Public.I("{FROM_AGENT} forwarded the chat to {TO_AGENT}")
        .replace("{FROM_AGENT}", m.from).replace("{TO_AGENT}", m.to)
      ;

      return text;
    },
    renderForwardToArea: function (m) {
      let text;

      text = Public.I("{FROM_AGENT} forwarded the chat to area {AREA_NAME}")
        .replace("{FROM_AGENT}", m.from)
        .replace("{AREA_NAME}", m.areaName)
      ;

      return text;
    },
    renderSendChatHistory: function (m) {

      return Public.I("A copy of the chat will be sent to {CLIENT_EMAIL}")
        .replace("{CLIENT_EMAIL}", m.to);
    },
    renderAcceptChat: function (m) {
      return Public.I("{AGENT_NAME} joins the chat.")
        .replace("{AGENT_NAME}", m.who);
    },
    renderRejectChat: function (m) {
      return null;
    },
    renderChatExpired: function (m) {
      return Public.I("This chat has expired.");
    },
    renderOwnerEndsChat: function (m) {
      return Public.I("{AGENT_NAME} ended the chat.")
        .replace("{AGENT_NAME}", m.who);
    },
    format: function (json, clientId, agents) {
      let m = JSON.parse(json.text);
      if (!m) {
        return json;
      }
      let sysMsg = {sender: 'SYSTEM', fromClient: json.fromClient, text: json.text};
      switch (m.event) {
        case "SET_AGENTS":
          sysMsg.text = SystemMessage.renderSetAgentsEvent(m);
          break;
        case "AGENT_LEFT":
          sysMsg.text = SystemMessage.renderAgentLeftEvent(m);
          break;
        case "CLIENT_ENDS_CHAT":
          sysMsg.text = SystemMessage.renderClientEndsChat(m);
          break;
        case "ADD_ATTACHMENT":
          Array.prototype.contains = function (obj) {
            return this.indexOf(obj) > -1;
          };
          let isAgent = agents.indexOf(m.who);
          sysMsg.fromClient = isAgent <= -1;
          sysMsg.sender = m.name;
          sysMsg.text = SystemMessage.renderAttachmentAdded(m);
          break;
        case "FORWARD_TO_AGENT":
          sysMsg.text = SystemMessage.renderForwardToAgent(m);
          break;
        case "FORWARD_TO_AREA":
          sysMsg.text = SystemMessage.renderForwardToArea(m);
          break;
        case "SEND_CHAT_HISTORY":
          sysMsg.text = SystemMessage.renderSendChatHistory(m);
          break;
        case "ACCEPT_CHAT":
          sysMsg.text = SystemMessage.renderAcceptChat(m);
          break;
        case "REJECT_CHAT":
          sysMsg.text = null;
          break;
        case "CHAT_EXPIRED":
          sysMsg.text = SystemMessage.renderChatExpired(m);
          break;
        case "OWNER_ENDS_CHAT":
          sysMsg.text = SystemMessage.renderOwnerEndsChat(m);
          break;
      }
      return sysMsg;
    }
  };

  that.maybeFormat = function (message) {
    let j
      , orig = message.text
    ;
    if (!isJSONPayload(message.text)) {
      return;
    }

    try {
      j = that.parseJSONMessage(message.text);
      if(j.event == "FILE_UPLOAD") {
        message.text = renderFileUploadMessage(j);
      }
    } catch (e) {
      message.text = orig;
    }
  };

  that.bindEvents = function (socket, parameters) {
    socket.on('unsentmessages', function () {
      that.emitMessage();
    });
    socket.on('status', function (cb) {
      // Don't put any unicode characters in response - it
      // won't work on some versions of IE.
      let response = {
        forcelongpolling: socket.forcedLongPolling
      };
      cb(response);
    });
    socket.on('pong', function () {
      that.io.lastPong = (new Date()).getTime();
    });

    socket.on('connect_error', function (err) {
      invokeAction('connect_error', err);
    });

    socket.on('connect', function () {
      if (!Public.sessionSecret) {
        that.register(parameters);
      } else {
        that.reconnect();
      }
    })

    socket.onJson('register', function (msg, cb) {
      that.connected = true;
      if (msg.status === 'OFFLINE') {
        Public.disconnect();
      } else if (msg.status === 'CLOSED') {
        invokeAction('chat closed');
      } else {
        Public.sessionSecret = msg.sessionSecret;
        Public.sessionId = msg.sessionId;
        Public.areaId = msg.areaId;
        Public.activeSession = true;
        Public.haveCookie = msg.haveCookie;

        invokeAction('connect', msg);
      }
      cb('client ' + msg.status);
    });

    socket.on('agent unavailable', function () {
      invokeAction('agent unavailable');
    });

    socket.on('queue full', function () {
      invokeAction('queue full');
    });

    socket.onJson('chat message', function (cm, ack) {
      let data
        , i
        , messageId
        , message
        , ackedids = []
      ;
      if (!cm) {
        return;
      }

      data = cm.session;
      data.chat = cm.messages;
      let agentIds = cm.session.agentIds;
      for (i = 0; i < cm.messages.length; i++) {
        message = cm.messages[i];
        if (message.fromClient) {
          if (!that.agentSeen.hasOwnProperty(message.id)) {
            that.agentSeen[message.id] = false;
          }
          message.sender = 'CLIENT';
          message.read = message.id <= data.amaxId;
          that.maybeFormat(message);
        } else if (message.aid > 0) {
          message.sender = 'AGENT';
          that.maybeFormat(message);
        } else {
          let oSysMsg = SystemMessage.format(message, data.clientId, agentIds);
          message.sender = oSysMsg.sender;
          message.text = oSysMsg.text;
          message.fromClient = oSysMsg.fromClient;
        }
      }
      actionHandlers['chat message'].call(null, data);
      for (i = 0; i < cm.messages.length; i++) {
        messageId = cm.messages[i].id;
        // Remember that we have received this message
        if (isInt(messageId)) {
          that.mcount[messageId] = true;
        }

      }

      if (that.maxAcked < data.amaxId) {
        for (let id in that.agentSeen) {
          if (that.agentSeen[id]) {
            continue;
          }
          if (id <= data.amaxId) {
            that.agentSeen[id] = true;
            ackedids.push(id);
          }
        }
        that.maxAcked = data.amaxId;

        if (ackedids.length > 0) {
          invokeAction('message acked', {ids: ackedids});
        }
      }
      ack(Object.keys(that.mcount).length, cm.messages.length);
    });

    socket.onJson('agent preview', function (data) {
      invokeAction('agent preview', data);
    });

    socket.on('queue', function (n) {
      if (that.queuePosition === -1 || n < that.queuePosition) {
        that.queuePosition = n;
        invokeAction('queue', n);
      }
    });

    socket.on('finish chat session', function () {
      Public.activeSession = false;
      Public.disconnect();
      invokeAction('finish chat session');
    });

    socket.onJson('session reconnect', function (msg) {
      that.connected = true;
      switch (msg.status) {
        case 'TRY_AGAIN':
          setTimeout(function () {
            log('Reconnection failed, retry sending reconnect..');
            that.reconnect();
          }, 4000);
          break;
        case 'OFFLINE':
          invokeAction('chat closed');
          break;
      }
    });

    socket.onJson('message acked', function (msg) {
      let i;
      for (i = 0; i < msg.ids.length; i++) {
        if (that.maxAcked < msg.ids[i]) {
          that.maxAcked = msg.ids[i];
        }
        that.agentSeen[msg.ids[i]] = true;
      }
      invokeAction('message acked', msg);
    });
  };

  function invokeAction(action) {
    let handler = actionHandlers[action];
    if (handler) {
      return handler.apply(self, Array.prototype.slice.apply(arguments, [1]), Array.prototype.slice.apply(arguments, [2]));
    }
  }

  Public.registerAction = function (action, handler) {
    actionHandlers[action] = handler;
    if (action === 'message sent') {
      that.updateUnsentMessage = handler;
    }
  };

  that.io = {
    forcelongpolling: false,
    pongTimeout: 60 * 1000,
    lastPong: 0,
    watchDogEnabled: false
  };
  that.forceLongPolling = function () {
    if (!that.io.forcelongpolling) {
      if (chatSock) {
        chatSock.disconnect();
        chatSock = null;
      }
      that.io.forcelongpolling = true;
      Public.connect();
    }
  };
  that.connected = false; // true when we have successfully registered or reconnected
  that.reconnectTimeoutId = null;

  that.watchDog = function () {
    let now;

    if (!Public.activeSession) {
      return;
    }

    if (that.io.forcelongpolling) {
      return;
    }

    now = (new Date()).getTime();
    if ((now - that.io.lastPong) > that.io.pongTimeout) {
      that.forceLongPolling();
    } else {
      setTimeout(that.watchDog, that.io.pongTimeout);
    }
  };

  Public.bytesToSize = function (bytes) {
    return bytesToSize(bytes);
  };
  Public.connect = function (parameters, ioparams) {
    let ioOpt
      , forcedLongPolling = false
    ;
    that.connected = false;
    if (!chatSock) {
      ioOpt = {
        path: '/socket/external.io'
      };
      if (ioparams) {
        if (ioparams.forcelongpolling || that.io.forcelongpolling) {
          forcedLongPolling = true;
          ioOpt.transports = ['polling'];
        }
        if (typeof ioparams.multiplex !== 'undefined') {
          ioOpt.multiplex = ioparams.multiplex;
        }
      }
      if (parameters) {
        if (!Public.areaId) {
          Public.areaId = parameters.area;
        }
        if (parameters.langCode) {
          Public.langCode = parameters.langCode;
        }
      }
      chatSock = SockWrap(io(Public.baseURL || window.location.origin, ioOpt), forcedLongPolling);
      that.bindEvents(chatSock, parameters);

      if (!that.io.forcelongpolling && !that.io.watchDogEnabled) {
        that.io.watchDogEnabled = true;
        setTimeout(that.watchDog, that.io.pongTimeout);
      }
    } else {
      chatSock.connect();
      if (!Public.sessionSecret) {
        that.register(parameters);
      } else {
        that.reconnect();
      }
    }

    clearTimeout(that.reconnectTimeoutId);
    that.reconnectTimeoutId = setTimeout(function () {
      if (that.connected) {
        return;
      }
      // TODO force long polling if there are many reconnection attempts
      that.forceLongPolling();
    }, 60 * 1000);
  };

  Public.tryResume = function (cb) {
    let url = Public.baseURL + "/socket/external.api/canresume";
    jQuery.ajax({
      url: url,
      type: 'GET',
      xhrFields: {withCredentials: true}
    })
      .done(function (msg) {
        if (msg.error) {
          cb(msg);
        } else {
          Public.connect({callback: cb, resume: true, area: -1});
        }
      })
      .fail(function (jqXHR, textStatus, errorThrown) {
        log("error loading " + url, textStatus, errorThrown);
        cb({'error': 'resume failed'});
      });
  };

  Public.disconnect = function () {
    Public.activeSession = false;
    chatSock.disconnect();
    chatSock = null;
  };

  that.unsentMessageId = 0;
  that.unsentMessages = [];
  that.emitMessage = function () {
    let um;

    if (that.unsentMessages.length === 0) {
      return;
    }

    um = that.unsentMessages[0];
    chatSock.emit('chat message', {
      id: um.id,
      message: um.message,
      mcount: Object.keys(that.mcount).length
    }, function (ack) {
      if (ack.error) {
        switch (ack.error) {
          case 'ERR_NIL_CHAT':
            that.reconnect();
          // fall through
          case 'ERR_TRY_AGAIN':
            setTimeout(that.emitMessage, 4000);
            return;
          case 'ERR_INVALID_MESSAGE_ID':
            // This should not happen
            throw new Error("received ERR_INVALID_MESSAGE_ID: " + um.id);
          case 'ERR_ALREADY_SEEN':
            if (that.unsentMessages.length > 0 && um.id === that.unsentMessages[0].id) {
              um = that.unsentMessages.shift();
              um.messageId = 'already-seen-' + um.id;
              that.mcount[um.messageId] = true;
              that.updateUnsentMessage && that.updateUnsentMessage({
                id: um.messageId,
                umid: um.id,
                sentHuman: 'NN:NN' // FIXME make back end return the timestamp
              });
            }
            break;
          default:
            throw new Error(`unhandled ack.error '${ack.error}'`);
        }
      } else {
        um = that.unsentMessages.shift();
        if (um.id === ack.umid) {
          um.messageId = ack.id;
          um.sentHuman = ack.sentHuman;
          that.updateUnsentMessage && that.updateUnsentMessage({
            id: ack.id,
            umid: ack.umid,
            sentHuman: ack.sentHuman
          });
          if (!that.agentSeen.hasOwnProperty(ack.id)) {
            that.agentSeen[ack.id] = false;
          }
        }
      }

      if (that.unsentMessages.length > 0) {
        that.emitMessage();
      }
    });
  };

  that.getNewMessageId = function () {
    let timestamp = (new Date()).getTime();

    that.unsentMessageId++;
    return `c-${timestamp}-${that.unsentMessageId}`;
  };
  that.addUnsentMessage = function (message) {
    let um
      , id = that.getNewMessageId()
    ;
    um = {
      message: message,
      id: id
    };
    that.unsentMessages.push(um);
    if (Public.activeSession) {
      if (that.unsentMessages.length === 1) {
        that.emitMessage();
      }
    }
    return um;
  };

  Public.message = function (message) {
    return that.addUnsentMessage(message);
  };

  Public.preview = function (message) {
    if (Public.activeSession) {
      chatSock.emit('preview', message);
    }
  };

  that.reconnect = function () {
    chatSock.emit('session reconnect', {
      area: Public.areaId,
      sessionId: Public.sessionId,
      sessionSecret: Public.sessionSecret,
      langCode: Public.langCode
    });
  };

  Public.close = function () {
    chatSock.emit('close chat');
  };

  that.register = function (parameters) {
    if (parameters && parameters.resume) {
      chatSock.emit('resume', window.location.href, function (msg) {
        that.connected = true;
        if (msg.error) {
          chatSock.disconnect();
          chatSock = null;
          parameters.callback && parameters.callback(msg);
          return;
        }
        Public.sessionSecret = msg.sessionSecret;
        Public.sessionId = msg.sessionId;
        Public.areaId = msg.areaId;
        Public.activeSession = true;
        if (msg.langCode) {
          Public.langCode = msg.langCode;
        }
        parameters.callback && parameters.callback(msg);
        chatSock.emit('sendchat', "resume existing chat", function (ack) {
          if (ack.error) {
            log('sendchat error', ack.error);
          }
        });
      });
    } else {
      chatSock.emit('register', parameters);
    }
  };

  that.isWithinSizeLimit = function (estFileSize) {
    let maxFileAllowed = CentionChatStatus.feature['chat.max-attachment-size'];
    if (typeof maxFileAllowed === 'undefined' || maxFileAllowed <= 0) {
      return true // don't care about the file limits
    }
    return estFileSize <= maxFileAllowed;

  };

  that.JSONMessage = function (j) {
    return JSON_ENCODED + JSON.stringify(j);
  };

  that.parseJSONMessage = function (text) {
    return JSON.parse(text.replace(JSON_ENCODED, ''));
  };

  Public.attachFile = function (file, callback) {
    if (!file || typeof (file) === 'undefined') {
      return;
    }
    if (!that.isWithinSizeLimit(file.size)) {
      alert(I("The uploaded file has exceeded the max allowed size."));
      return;
    }
    let xhr = [];
    let formData = new FormData();
    let boundary = `${Math.floor(Math.random() * 6)}0${Math.floor('' + new Date() / 1000)}`;
    formData.append("uploadfile", file);
    formData.append('random', parseFloat(boundary));
    formData.append('session', Public.sessionId);
    formData.append('area', Public.areaId);
    formData.append('sessionSecret', Public.sessionSecret);
    xhr[0] = new XMLHttpRequest();
    xhr[0].open("POST", Public.baseURL + "/Cention/web/chat/client/uploadAttachment");
    xhr[0].onreadystatechange = function (ev) {
      if (ev.target.readyState === 4 && ev.target.status === 200) {
        let ro = JSON.parse(ev.target.responseText);
        /*Send callback to parent for every file upload*/
        chatSock.emit('add attachment', {
          area: Public.areaId,
          sessionSecret: Public.sessionSecret,
          file: ro
        }, function (ack) {
          let j = {
              "event": "FILE_UPLOAD",
              "fileDownload": ack.file.download,
              "fileName": ack.file.value,
              "estimatedSize": ack.file.estSize,
              "error": ack.error
            }
            , um = Public.message(that.JSONMessage(j))
          ;
          callback({
            unsent: true,
            text: renderFileUploadMessage(j),
            fromClient: true,
            sender: "CLIENT",
            id: "unsent-" + um.id
          });
        });
      }
    };
    xhr[0].send(formData);
  };

  Public.attachImage = function (fileData) {
    let fd = new FormData();
    let boundary = `${Math.floor(Math.random() * 6)}${1}${Math.floor('' + new Date() / 1000)}`;
    fd.append('uploadfile', fileData);
    fd.append('random', boundary);
    fd.append('area', Public.areaId);
    fd.append('session', Public.sessionId);
    fd.append('sessionSecret', Public.sessionSecret);

    return jQuery.ajax({
      url: Public.baseURL + "/Cention/web/chat/client/uploadTempAttachment",
      data: fd,
      processData: false,
      contentType: false,
      type: 'POST',
    });
  };

  Public.moveImage = function (fileIds, fileNames) {
    let fd = new FormData();
    fd.append('fileIds', fileIds);
    fd.append('fileNames', fileNames);
    fd.append('session', Public.sessionId);

    return jQuery.ajax({
      url: Public.baseURL + "/Cention/web/chat/client/moveTempAttachment",
      data: fd,
      processData: false,
      contentType: false,
      type: 'POST',
    });
  };

  function areaQuery(areaId, path, callback) {
    let url = `${Public.baseURL}/socket/external.api${path}`;
    jQuery.ajax({
      url: url,
      data: {area: areaId},
      type: 'GET',
      xhrFields: {withCredentials: true}
    })
      .done(function (data) {
        callback(data);
      }.bind(this))
      .fail(function (jqXHR, textStatus, errorThrown) {
        log("error loading " + url, textStatus, errorThrown);
        callback({'error': 'chat connection failed'});
      });
  }

  Public.canChat = function (handleData, areaId) {
    areaQuery(areaId, "/canchat", function (data) {
      if (FOR_THIRD_PARTY_USE) {
        CentionChatStatus.feature = data.feature;
      }
      handleData(data);
    });
  };

  Public.resetChat = function () {
    that.mcount = {};
  };

  return Public;
};

const CentionChat = _CentionChat();
CentionChat.baseURL = '//chat-postnord.clearinteract.se';
window.CentionChat = CentionChat;

(function (win, doc, url, name, tag) {
  // get all humany options from the search bar and append them in the url
  // Example:
  // http://example.com?humany=foo&humany_bar=bar&ts=1238999 should result to
  // postnord.humany.net/shipping-tool/embed.js?humany=foo&humany_bar=bar
  for (let o of win.location.search.matchAll(/[?&]{1}(humany[^=]*)=([^&#]*)/g))
    url = `${url + (url.indexOf('?') > -1 ? '&' : '?') + o[1]}=${o[2]}`;

  // create the humany script tag
  let el = doc.createElement(tag);
  el.async = !0;
  el.src = url;

  // insert the humany script before the first script tag
  let e = doc.getElementsByTagName(tag)[0];
  e.parentNode.insertBefore(el, e);

  // add humany in the global window
  win[name] = win[name] || {
    _c: [],
    configure: function (config) {
      win[name]._c.push(config);
    },
  };
})(window, document, '//postnord.humany.net/shipping-tool/embed.js', 'Humany', 'script');

